import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalizedLoaded,
} from "vue-router";

import Blank from "@/layouts/blank.vue";
import Default from "@/layouts/default.vue";
import { publicKonekRoutes } from "@/router/routes/public.routes";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: Default,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import("@/pages/dashboard/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Home",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "quotation",
          name: "quote-request",
          component: () => import("@/pages/quote-request/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Quotation",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "customers",
          name: "customers",
          alias: ["customers-source", "customer-source"],
          component: () => import("@/pages/customers/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Customers",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "customers/create",
          name: "customers-create",
          component: () => import("@/views/customers/CustomerFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "customers",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Customers",
                to: { name: "customers" },
                disabled: true,
              },
              {
                title: "Add Customer",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "customers/:id",
          name: "customers-detail",
          component: () => import("@/views/customers/CustomerDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "customers",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Customers",
                to: { name: "customers" },
                disabled: true,
              },
              {
                title: "Customer Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "bookings",
          name: "bookings",
          component: () => import("@/pages/bookings/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Bookings",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "agents",
          name: "agents",
          component: () => import("@/pages/agents/index.vue"),
          meta: {
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Agents",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "agents/create",
          name: "agents-create",
          component: () => import("@/views/agents/AgentFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "agents",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Agents",
                to: { name: "agents" },
                disabled: true,
              },
              {
                title: "Add Agent",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "agents/:id/edit",
          name: "agents-edit",
          component: () => import("@/views/agents/AgentFormView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "agents",
            requiresAuth: true,
            breadcrumbs: [
              { title: "Agents", to: { name: "agents" }, disabled: true },
              { title: "Edit Agent", disabled: true },
            ],
          },
        },
        {
          path: "agents/:id",
          name: "agents-detail",
          component: () => import("@/views/agents/AgentDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "agents",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Agents",
                to: { name: "agents" },
                disabled: true,
              },
              {
                title: "Agent Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "pets",
          name: "pets",
          component: () => import("@/pages/pets/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Pets",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "pets/create",
          name: "pets-create",
          component: () => import("@/views/pets/PetFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "pets",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Pets",
                to: { name: "pets" },
                disabled: true,
              },
              {
                title: "Add Pet",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "pets/:id/edit",
          name: "pets-edit",
          component: () => import("@/views/pets/PetFormView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "pets",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Pets",
                to: { name: "pets" },
                disabled: true,
              },
              {
                title: "Edit Breed",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "pets/:id",
          name: "pet-detail",
          component: () => import("@/views/pets/PetDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "pets",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Pets",
                to: { name: "pets" },
                disabled: true,
              },
              {
                title: "Pet Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "crates",
          name: "crates",
          component: () => import("@/pages/crates/index.vue"),
          meta: {
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Crates",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "crates/create",
          name: "crates-create",
          component: () => import("@/views/crates/CrateFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "crates",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Crates",
                to: { name: "crates" },
                disabled: true,
              },
              {
                title: "Add Crate",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "crates/:crateReferenceNo/edit",
          name: "crates-edit",
          component: () => import("@/views/crates/CrateFormView.vue"),
          props: (route) => ({
            crateReferenceNo: String(route.params.crateReferenceNo),
          }),
          meta: {
            fullbleed: true,
            navActiveLink: "crates",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Crates",
                to: { name: "crates" },
                disabled: true,
              },
              {
                title: "Edit Crate",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "crates/:crateReferenceNo",
          name: "crates-detail",
          component: () => import("@/views/crates/CrateDetailView.vue"),
          props: (route) => ({
            crateReferenceNo: String(route.params.crateReferenceNo),
          }),
          meta: {
            fullbleed: true,
            navActiveLink: "crates",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Crates",
                to: { name: "crates" },
                disabled: true,
              },
              {
                title: "Crate Detail",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "documents",
          name: "documents",
          component: () => import("@/pages/documents/index.vue"),
          meta: {
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Documents",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "documents/create",
          name: "documents-create",
          component: () => import("@/views/documents/DocumentsFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "documents",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Documents",
                to: { name: "documents" },
              },
              {
                title: "New Document",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "documents/:id/edit",
          name: "documents-edit",
          component: () => import("@/views/documents/DocumentsFormView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "documents",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Documents",
                to: { name: "documents" },
              },
              {
                title: "Edit",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "documents/:id",
          name: "documents-detail",
          component: () => import("@/views/documents/DocumentsDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "documents",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Documents",
                to: { name: "documents" },
              },
              {
                title: "Document Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "requirements",
          name: "requirements",
          component: () => import("@/pages/requirements/index.vue"),
          meta: {
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Requirements",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "requirements/create",
          name: "requirements-create",
          component: () =>
            import("@/views/requirements/RequirementsFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "requirements",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Requirements",
                to: { name: "requirements" },
              },
              {
                title: "New Requirement",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "requirements/:id/edit",
          name: "requirements-edit",
          component: () =>
            import("@/views/requirements/RequirementsFormView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "requirements",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Requirements",
                to: { name: "requirements" },
              },
              {
                title: "Edit",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "requirements/:id",
          name: "requirements-detail",
          component: () =>
            import("@/views/requirements/RequirementsDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "requirements",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Requirements",
                to: { name: "requirements" },
              },
              {
                title: "Requirement Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "activities",
          name: "activities",
          component: () => import("@/pages/activities/tasks/index.vue"),
          meta: {
            fullbleed: true,
            requiresAuth: true,
            breadcrumbs: (route: RouteLocationNormalizedLoaded) =>
              route.query.action === "new"
                ? [
                    {
                      title: "Activities",
                      to: { name: "activities" },
                      disabled: true,
                    },
                    {
                      title: "New Activity",
                      disabled: true,
                    },
                  ]
                : [
                    {
                      title: "Activities",
                      disabled: true,
                    },
                  ],
          },
        },
        {
          path: "activities/:id",
          name: "activities-detail",
          component: () => import("@/views/activities/TasksDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "activities",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Activities",
                to: { name: "activities" },
                disabled: true,
              },
              {
                title: "Activity Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "quotation/create",
          name: "quote-request-create",
          component: () =>
            import("@/views/quote-request/QuoteRequestFormView.vue"),
          meta: {
            fullbleed: true,
            navActiveLink: "quote-request",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Quotation",
                to: { name: "quote-request" },
                disabled: true,
              },
              {
                title: "New Quotation",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "quotation/:id/edit",
          name: "quote-request-edit",
          component: () =>
            import("@/views/quote-request/QuoteRequestFormView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "quote-request",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Home",
                to: { name: "dashboard" },
              },
              {
                title: "Quotation",
                to: { name: "quote-request" },
              },
              {
                title: "Edit",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "quotation/:id",
          name: "quote-request-detail",
          component: () =>
            import("@/views/quote-request/QuoteRequestDetailView.vue"),
          props: (route) => ({ id: Number(route.params.id) }),
          meta: {
            fullbleed: true,
            navActiveLink: "quote-request",
            requiresAuth: true,
            breadcrumbs: [
              {
                title: "Quotation",
                to: { name: "quote-request" },
                disabled: true,
              },
              {
                title: "Quotation Details",
                disabled: true,
              },
            ],
          },
        },
        {
          path: "quote-request",
          redirect: { name: "quote-request" },
        },
        {
          path: "quote-request/create",
          redirect: { name: "quote-request-create" },
        },
        {
          path: "quote-request/:id/edit",
          redirect: (to) => ({
            name: "quote-request-edit",
            params: to.params,
            query: to.query,
          }),
        },
        {
          path: "quote-request/:id",
          redirect: (to) => ({
            name: "quote-request-detail",
            params: to.params,
            query: to.query,
          }),
        },
      ],
    },

    {
      path: "/konek",
      component: Blank,
      children: publicKonekRoutes,
    },

    {
      path: "/login",
      component: Blank,
      meta: { guestOnly: true },
      children: [
        {
          path: "",
          name: "login",
          component: () => import("@/pages/auth/login.vue"),
        },
      ],
    },

    {
      path: "/:pathMatch(.*)*",
      component: Blank,
      children: [
        {
          path: "",
          name: "not-found",
          component: () => import("@/pages/[...error].vue"),
        },
      ],
    },
  ],
});

export default router;
